import { reactive } from 'vue'
export const State = {
	user:{
		id: '',
		userName: '',
		nickName: '',
		photo: '',
		mobile: '',
		admin: false,
		sysFlag: '',
		isValid: false,
		vipId:'',
	},
	breadcrumb:[],
	pageTags:[],
	currChatUser:{},//当前聊天用户
	indexContentTabs:[],//资讯首页tab
	indexLiveTabs:[],//直播首页的tab
	chatroomCommonWords:[],//聊天室快捷文本
	shieldList:[],//屏蔽列表（不看ta）
	startUp:{},//启动数据
	notification:false,//是否开启通知
	chatMsgNotice:false,//聊天通知
	friendList:[],//好友列表
	customerServiceList:[],//客服列表
}

export function createState() {
	return reactive(State)
}
